import * as languages from './languages';

export default {
  ...languages,
};
